import { render } from "./ParticipantDetailsModal.vue?vue&type=template&id=2c2b1f6e"
import script from "./ParticipantDetailsModal.vue?vue&type=script&lang=js"
export * from "./ParticipantDetailsModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/suryaardiansah/Documents/Project/Programming/Vue/BACKUPP/vue-backup/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__